const ITEMS = ["Handcrafted in Delhi", "Since 2002", "Manufacturer Direct", "Premium Metal Décor", "Wholesale & Retail"];

export default function Marquee() {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className={`font-serif text-2xl md:text-4xl tracking-tight px-8 md:px-12 whitespace-nowrap ${i % 2 ? "italic text-gold" : ""}`}>{item}</span>
          <span className="w-2 h-2 rotate-45 bg-gold shrink-0" />
        </span>
      ))}
    </div>
  );
  return (
    <div className="marquee-hover overflow-hidden border-b border-black/10 py-6 md:py-8 select-none" data-testid="editorial-marquee" aria-hidden="true">
      <div className="flex w-max animate-marquee">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
}
